import { useState } from "react";
import { Outlet } from "react-router-dom";
import { Menu } from "lucide-react";
import Sidebar from "./Sidebar";
import Logo from "../Logo";

export default function AppLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="flex h-screen overflow-hidden bg-mist">
      <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />

      <main className="flex-1 overflow-hidden flex flex-col min-w-0">
        {/* Mobile header */}
        <div className="lg:hidden flex items-center gap-3 px-4 py-3 bg-white border-b border-gray-100">
          <button
            onClick={() => setSidebarOpen(true)}
            className="p-1.5 -ml-1 text-slate hover:text-ink"
            aria-label="Open menu"
          >
            <Menu className="h-5 w-5" />
          </button>
          <Logo size={26} />
        </div>

        {/* Main content — subtle indigo radial wash per the App Template */}
        <div
          className="flex-1 overflow-y-auto"
          style={{
            background:
              "radial-gradient(1200px 700px at 60% 30%, #EEEFFB 0%, #F7F7FA 55%, #F7F7FA 100%)",
          }}
        >
          <div className="max-w-6xl mx-auto px-5 py-8 sm:px-10 sm:py-10">
            <Outlet />
          </div>
        </div>
      </main>
    </div>
  );
}
